import styled from '@emotion/styled';
import type { PredictionParams } from '@racemap/utilities/types/events';
import type {
  AcceptedReadRust,
  PredictionDebugData,
  RejectedReadRust,
} from '@racemap/utilities/types/trackping';
import React, { type FC } from 'react';
import { ItemsOverOffsetChart } from '../ItemsOverOffsetChart';
import { ReadersMap } from '../ReadersMap';

interface MapCardProps {
  predictionParams: PredictionParams | null;
  starterDebugData: PredictionDebugData | null;
  showRejectedReads: boolean;
}

export const MapCard: FC<MapCardProps> = ({
  predictionParams,
  starterDebugData,
  showRejectedReads,
}) => {
  const [acceptedReadInFocus, setacceptedReadInFocus] = React.useState<AcceptedReadRust | null>(
    null,
  );
  const [rejectedReadInFocus, setrejectedReadInFocus] = React.useState<RejectedReadRust | null>(
    null,
  );
  const [hoveredPosition, setHoveredPosition] = React.useState<number | null>(null);

  return (
    <ReaderWrapper>
      <ReadersMap
        showLegend
        acceptedReads={starterDebugData?.acceptedReads || []}
        rejectedReads={starterDebugData?.rejectedReads || []}
        showRejectedReads={showRejectedReads}
        predictionParams={predictionParams}
        hoveredPosition={hoveredPosition}
        acceptedReadInFocus={acceptedReadInFocus}
        onAcceptedReadInFocusChange={setacceptedReadInFocus}
        rejectedReadInFocus={rejectedReadInFocus}
        onRejectedReadInFocusChange={setrejectedReadInFocus}
      />

      <ItemsOverOffsetChart
        acceptedReads={starterDebugData?.acceptedReads || []}
        withSplitChart={false}
        onHoverPosition={setHoveredPosition}
        acceptedReadInFocus={acceptedReadInFocus}
        onAcceptedReadInFocusChange={setacceptedReadInFocus}
      />
    </ReaderWrapper>
  );
};

const ReaderWrapper = styled.div`
  display: grid;
  grid-template-rows: 700px;
  grid-template-areas: 'map';
  width: 100%;
  min-width: 0;
  overflow: hidden;
`;
